import { Component, OnInit } from '@angular/core';

import { UserblockService } from './userblock.service';
import { User } from "../../../routes/users/user";
import 'rxjs/add/operator/toPromise';
import {UsersService} from "../../../routes/users/users/users.service";


@Component({
  selector: 'app-userblock',
  templateUrl: './userblock.component.html',
  styleUrls: ['./userblock.component.scss']
})
export class UserblockComponent implements OnInit {

    private UBER_ORG_NAME = 'Uber Admin';
    public me: User;

    constructor(private userblockService: UserblockService, private usersService: UsersService) {
    }

    ngOnInit() {
        this.usersService.getUsersMe(true).toPromise().then( me => this.me = me)
    }

    userBlockIsVisible() {
        return this.userblockService.getVisibility();
    }

    getUserName() {
        if (this.me && this.me.organizations.length > 0) {
            if (this.me.organizations[0]._id) {
                return this.me.organizations[0].company_user.first_name + ' ' +
                    this.me.organizations[0].company_user.last_name + ' ' +
                    this.me.organizations[0].company_user.last_name_2;
            }
        }
    }

    getOrganizationName() {
        if (this.me && this.me.organizations.length > 0) {
            if (this.me.organizations[0]._organization) {
                return this.me.organizations[0]._organization.name;
            } else {
                return this.UBER_ORG_NAME;
            }
        }
    }

    getEmail() {
        if (this.me && this.me.organizations.length > 0) {
            if (this.me.organizations[0]._id) {
              return this.me.organizations[0].company_user.email;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/layout/sidebar/userblock/userblock.component.ts